// Action Types
export const FETCH_CONTACT_CARD_REQUEST = "FETCH_CONTACT_CARD_REQUEST";
export const FETCH_CONTACT_CARD_SUCCESS = "FETCH_CONTACT_CARD_SUCCESS";
export const FETCH_CONTACT_CARD_FAILURE = "FETCH_CONTACT_CARD_FAILURE";

// Action Creators
export const fetchContactCardRequest = ({opportunityId,userId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_CONTACT_CARD_REQUEST,
      payload: {opportunityId,userId},
    });
  };
};
export const fetchContactCardSuccess = (data) => ({
  type: FETCH_CONTACT_CARD_SUCCESS,
  payload: data,
});
export const fetchContactCardFailure = (error) => ({
  type: FETCH_CONTACT_CARD_FAILURE,
  payload: error,
});
